export default __webpack_public_path__ + "static/media/0.aba604a1.jpg";